import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import {
    BaasicButton,
    BaasicTable,
    TableFilter,
    EmptyState,
    QueryDropdown,
    DateQueryPicker
} from "core/components";
import { ApplicationListLayout, Content } from "core/layouts";
import { isSome } from 'core/utils';

const FacilityInventoryCountListTemplate = function({ facilityInventoryCountListViewStore }) {
    
    const { 
        tableStore, 
        routes,
        queryUtility, 
        authorization, 
        personStore, 
        facilityStore,  
        countDatePickerStore
    } = facilityInventoryCountListViewStore;

    return (
        <ApplicationListLayout
            store={facilityInventoryCountListViewStore}
            authorization={authorization}
        >
            <Content emptyRenderer={renderEmpty(routes)}>
                <div className="u-mar--bottom--sml">
                    <TableFilter queryUtility={queryUtility} showSearchFilter={false} filterVisible={true}>
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-3 form__group">
                            <QueryDropdown queryUtility={queryUtility} store={facilityStore} propertyName="facilityId" label="Facility"/>
                        </div>
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-3 form__group">
                            <QueryDropdown queryUtility={queryUtility} store={personStore} propertyName="authorId" label="Author"/>
                        </div>
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-3 form__group">
                            <label className="form__group__label">Count Date</label>
                            <DateQueryPicker store={countDatePickerStore} queryUtility={queryUtility} propertyName="countDate" />
                        </div>  
                    </TableFilter>
                </div>
                <div className="card--primary">
                    <BaasicTable
                        authorization={authorization}
                        tableStore={tableStore}
                        actionsComponent={renderActions}
                    />
                </div>
            </Content>
        </ApplicationListLayout>
    );
};

function renderEmpty(routes) {
    return (
        <EmptyState
            title="FACILITY_INVENTORY.LIST.EMPTY_STATE.TITLE"
            callToAction={routes.create}
        />
    );
}

FacilityInventoryCountListTemplate.propTypes = {
    facilityInventoryCountListViewStore: PropTypes.object.isRequired
};

function renderActions({ item, actions, authorization }) {
    if (!isSome(actions)) return null;

    const { onEdit, onDone, onUndone, onDelete } = actions;
    if (!isSome(onEdit) && !isSome(onDone) && !isSome(onUndone) && !isSome(onDelete)) return null;

    return (
        <td className="table__body--data right">
            <div className="table__icons">               
                {isSome(onEdit) && !item.isDone ? (
                    <BaasicButton
                        authorization={authorization ? authorization.update : null}
                        className="btn btn--icon"
                        icon='u-icon u-icon--edit u-icon--sml'
                        label='FACILITY_INVENTORY.LIST.BUTTON.EDIT'
                        onlyIcon={true}
                        onClick={() => onEdit(item)}>
                    </BaasicButton>
                ) : null}
                {(item.isDone) ? (
                    <BaasicButton
                        authorization={authorization ? authorization.update : null}
                        className="btn btn--icon"
                        icon='u-icon u-icon--locked u-icon--sml'
                        label='FACILITY_INVENTORY.LIST.BUTTON.LOCK'
                        onlyIcon={true}
                        onClick={() => onUndone(item)}>
                    </BaasicButton>
                ) : (
                    <BaasicButton
                        authorization={authorization ? authorization.update : null}
                        className="btn btn--icon"
                        icon='u-icon u-icon--unlocked u-icon--sml'
                        label='FACILITY_INVENTORY.LIST.BUTTON.UNLOCK'
                        onlyIcon={true}
                        onClick={() => onDone(item)}>
                    </BaasicButton>
                )}
                {isSome(onDelete) ? (
                    <BaasicButton
                        authorization={authorization ? authorization.delete : null}
                        className="btn btn--icon is-delete"
                        icon='u-icon u-icon--delete u-icon--sml'
                        label='FACILITY_INVENTORY.LIST.BUTTON.DELETE'
                        onlyIcon={true}
                        onClick={() => onDelete(item)}>
                    </BaasicButton>
                ) : null}
            </div>
        </td>
    )
}

renderActions.propTypes = {
    item: PropTypes.object,
    actions: PropTypes.object,
    authorization: PropTypes.any
};

export default defaultTemplate(FacilityInventoryCountListTemplate);